module.exports = __webpack_public_path__ + "static/media/modernHire.d27762b5.svg";